/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgLassoBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.95398 16.3762C11.4106 18.0304 12.3812 19.1337 12.3768 21.2003M7.8431 20.2339C10.0323 20.2339 10.5789 18.6865 10.5789 17.912C10.5789 17.1405 10.0309 15.593 7.8431 15.593C5.65388 15.593 5.1073 17.1405 5.1073 17.9135C5.1073 18.6865 5.65532 20.2339 7.8431 20.2339ZM11.9941 16.0464C4.49482 16.0464 2.62 11.6305 2.62 9.4225C2.62 7.21598 4.49482 2.80005 11.9941 2.80005C19.4934 2.80005 21.3682 7.21598 21.3682 9.4225C21.3682 11.6305 19.4934 16.0464 11.9941 16.0464Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgLasso = wrapIcon(SvgLassoBase);
export default SvgLasso;
